<style scoped>
.advrt-img {
    max-height: calc(100vh - 10rem);
}
</style>

<template>
    <modal
        type="custom"
        class="modal-4xl"
        v-if="advrt"
        :showDismiss="true"
        @backdrop="$emit('hide')"
    >
        <div class="flex flex-col items-center">
            <a
                v-if="advrt.advrtActTypeCode === 'URLPOP'"
                :href="advrt.advrtUrl"
                target="_blank"
            >
                <img class="advrt-img" :src="advrtDtlImgUrl" />
            </a>
            <img
                v-if="advrt.advrtActTypeCode === 'POP'"
                class="advrt-img"
                :src="advrtDtlImgUrl"
            />
        </div>
    </modal>
</template>

<script>
import modal from './modal.vue';
import ctx from '@/utils/ctx';

export default {
    props: {
        advrt: { type: Object }
    },
    components: {
        modal
    },
    computed: {
        advrtDtlImgUrl() {
            const imgId = this.advrt.advrtDtlImgId;
            return imgId ? ctx('/advrtImageFile/' + imgId) : undefined;
        }
    }
};
</script>
